import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export const SourceWalletTypes = WalletTransferType

export type SourceWalletType = (typeof SourceWalletTypes)[keyof typeof SourceWalletTypes]

export interface SourceWallet {
  walletId: string
  legacyWalletId?: number
  walletName: string
  currency: string
  balance: number
  walletType: SourceWalletType
}
